var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LogInfo"},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("willkommen zurück "+_vm._s(_vm.fetchUsername))])])}
var staticRenderFns = []

export { render, staticRenderFns }